/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOrUpdateProjectCommand } from '../models/create-or-update-project-command';
import { ListProjectBonusSettingFieldsQuery } from '../models/list-project-bonus-setting-fields-query';
import { ListProjectBonusSettingFieldsResult } from '../models/list-project-bonus-setting-fields-result';
import { ListProjectsQuery } from '../models/list-projects-query';
import { ListProjectsResult } from '../models/list-projects-result';
import { ProjectBonusSettingFieldDetailData } from '../models/project-bonus-setting-field-detail-data';
import { ProjectData } from '../models/project-data';
import { RemoveProjectCommand } from '../models/remove-project-command';
import { SetProjectBonusSettingFieldDetailCommand } from '../models/set-project-bonus-setting-field-detail-command';
import { SetProjectGlobalInformationsCommand } from '../models/set-project-global-informations-command';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectsList
   */
  static readonly ProjectsListPath = '/api/Projects/List';

  /**
   * Projektek lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsList$Plain$Response(params?: {
    body?: ListProjectsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListProjectsResult>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListProjectsResult>;
      })
    );
  }

  /**
   * Projektek lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsList$Plain(params?: {
    body?: ListProjectsQuery
  },
  context?: HttpContext

): Observable<ListProjectsResult> {

    return this.projectsList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListProjectsResult>) => r.body as ListProjectsResult)
    );
  }

  /**
   * Projektek lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsList$Response(params?: {
    body?: ListProjectsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListProjectsResult>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListProjectsResult>;
      })
    );
  }

  /**
   * Projektek lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsList(params?: {
    body?: ListProjectsQuery
  },
  context?: HttpContext

): Observable<ListProjectsResult> {

    return this.projectsList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListProjectsResult>) => r.body as ListProjectsResult)
    );
  }

  /**
   * Path part for operation projectsGet
   */
  static readonly ProjectsGetPath = '/api/Projects/Get';

  /**
   * Projekt lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGet$Plain$Response(params?: {
    Id?: number;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectData>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('WageCalculationId', params.WageCalculationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectData>;
      })
    );
  }

  /**
   * Projekt lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGet$Plain(params?: {
    Id?: number;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<ProjectData> {

    return this.projectsGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectData>) => r.body as ProjectData)
    );
  }

  /**
   * Projekt lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGet$Response(params?: {
    Id?: number;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectData>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('WageCalculationId', params.WageCalculationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectData>;
      })
    );
  }

  /**
   * Projekt lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGet(params?: {
    Id?: number;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<ProjectData> {

    return this.projectsGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectData>) => r.body as ProjectData)
    );
  }

  /**
   * Path part for operation projectsPost
   */
  static readonly ProjectsPostPath = '/api/Projects/Post/Post';

  /**
   * Projekt létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsPost$Plain$Response(params?: {
    body?: CreateOrUpdateProjectCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Projekt létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsPost$Plain(params?: {
    body?: CreateOrUpdateProjectCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.projectsPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Projekt létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsPost$Response(params?: {
    body?: CreateOrUpdateProjectCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Projekt létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsPost(params?: {
    body?: CreateOrUpdateProjectCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.projectsPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation projectsRemove
   */
  static readonly ProjectsRemovePath = '/api/Projects/Remove/Remove';

  /**
   * Projekt törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsRemove$Response(params?: {
    body?: RemoveProjectCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsRemovePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Projekt törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsRemove(params?: {
    body?: RemoveProjectCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.projectsRemove$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation projectsListProjectBonusSettingFields
   */
  static readonly ProjectsListProjectBonusSettingFieldsPath = '/api/Projects/ListProjectBonusSettingFields/ListProjectBonusSettingFields';

  /**
   * Projekt bónusz beállítás mezők listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsListProjectBonusSettingFields$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsListProjectBonusSettingFields$Plain$Response(params?: {
    body?: ListProjectBonusSettingFieldsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListProjectBonusSettingFieldsResult>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsListProjectBonusSettingFieldsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListProjectBonusSettingFieldsResult>;
      })
    );
  }

  /**
   * Projekt bónusz beállítás mezők listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsListProjectBonusSettingFields$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsListProjectBonusSettingFields$Plain(params?: {
    body?: ListProjectBonusSettingFieldsQuery
  },
  context?: HttpContext

): Observable<ListProjectBonusSettingFieldsResult> {

    return this.projectsListProjectBonusSettingFields$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListProjectBonusSettingFieldsResult>) => r.body as ListProjectBonusSettingFieldsResult)
    );
  }

  /**
   * Projekt bónusz beállítás mezők listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsListProjectBonusSettingFields()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsListProjectBonusSettingFields$Response(params?: {
    body?: ListProjectBonusSettingFieldsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListProjectBonusSettingFieldsResult>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsListProjectBonusSettingFieldsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListProjectBonusSettingFieldsResult>;
      })
    );
  }

  /**
   * Projekt bónusz beállítás mezők listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsListProjectBonusSettingFields$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsListProjectBonusSettingFields(params?: {
    body?: ListProjectBonusSettingFieldsQuery
  },
  context?: HttpContext

): Observable<ListProjectBonusSettingFieldsResult> {

    return this.projectsListProjectBonusSettingFields$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListProjectBonusSettingFieldsResult>) => r.body as ListProjectBonusSettingFieldsResult)
    );
  }

  /**
   * Path part for operation projectsSetGlobalInformations
   */
  static readonly ProjectsSetGlobalInformationsPath = '/api/Projects/SetGlobalInformations/SetGlobalInformations';

  /**
   * Projekt Globális információk szerkesztése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSetGlobalInformations()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsSetGlobalInformations$Response(params?: {
    body?: SetProjectGlobalInformationsCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsSetGlobalInformationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Projekt Globális információk szerkesztése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSetGlobalInformations$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsSetGlobalInformations(params?: {
    body?: SetProjectGlobalInformationsCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.projectsSetGlobalInformations$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation projectsGetBonusDetail
   */
  static readonly ProjectsGetBonusDetailPath = '/api/Projects/GetBonusDetail';

  /**
   * (Globális) bónusz lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsGetBonusDetail$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetBonusDetail$Plain$Response(params?: {
    ProjectId?: number;
    ProjectBonusSettingFieldId?: number;
    Global?: boolean;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectBonusSettingFieldDetailData>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsGetBonusDetailPath, 'get');
    if (params) {
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('ProjectBonusSettingFieldId', params.ProjectBonusSettingFieldId, {});
      rb.query('Global', params.Global, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('WageCalculationId', params.WageCalculationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectBonusSettingFieldDetailData>;
      })
    );
  }

  /**
   * (Globális) bónusz lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsGetBonusDetail$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetBonusDetail$Plain(params?: {
    ProjectId?: number;
    ProjectBonusSettingFieldId?: number;
    Global?: boolean;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<ProjectBonusSettingFieldDetailData> {

    return this.projectsGetBonusDetail$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectBonusSettingFieldDetailData>) => r.body as ProjectBonusSettingFieldDetailData)
    );
  }

  /**
   * (Globális) bónusz lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsGetBonusDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetBonusDetail$Response(params?: {
    ProjectId?: number;
    ProjectBonusSettingFieldId?: number;
    Global?: boolean;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectBonusSettingFieldDetailData>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsGetBonusDetailPath, 'get');
    if (params) {
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('ProjectBonusSettingFieldId', params.ProjectBonusSettingFieldId, {});
      rb.query('Global', params.Global, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('WageCalculationId', params.WageCalculationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectBonusSettingFieldDetailData>;
      })
    );
  }

  /**
   * (Globális) bónusz lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsGetBonusDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetBonusDetail(params?: {
    ProjectId?: number;
    ProjectBonusSettingFieldId?: number;
    Global?: boolean;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<ProjectBonusSettingFieldDetailData> {

    return this.projectsGetBonusDetail$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectBonusSettingFieldDetailData>) => r.body as ProjectBonusSettingFieldDetailData)
    );
  }

  /**
   * Path part for operation projectsSetBonusDetail
   */
  static readonly ProjectsSetBonusDetailPath = '/api/Projects/SetBonusDetail/SetBonusDetail';

  /**
   * (Globális) bónusz szerkesztése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsSetBonusDetail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsSetBonusDetail$Response(params?: {
    body?: SetProjectBonusSettingFieldDetailCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsSetBonusDetailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * (Globális) bónusz szerkesztése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsSetBonusDetail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  projectsSetBonusDetail(params?: {
    body?: SetProjectBonusSettingFieldDetailCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.projectsSetBonusDetail$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation projectsGetProjectInformation
   */
  static readonly ProjectsGetProjectInformationPath = '/api/Projects/GetProjectInformation/GetProjectInformation';

  /**
   * Projekttájékoztató lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsGetProjectInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetProjectInformation$Response(params?: {
    ProjectId?: number;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsGetProjectInformationPath, 'get');
    if (params) {
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('WageCalculationId', params.WageCalculationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Projekttájékoztató lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsGetProjectInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsGetProjectInformation(params?: {
    ProjectId?: number;
    RequestUserId?: number;
    WageCalculationId?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.projectsGetProjectInformation$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation projectsUploadProjectInformation
   */
  static readonly ProjectsUploadProjectInformationPath = '/api/Projects/UploadProjectInformation/UploadProjectInformation';

  /**
   * Projekttájékoztató feltöltése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsUploadProjectInformation()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsUploadProjectInformation$Response(params?: {
    body?: {
'RequestUserId'?: number;
'ProjectId'?: number;
'DocumentGroupId'?: string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectsService.ProjectsUploadProjectInformationPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Projekttájékoztató feltöltése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsUploadProjectInformation$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsUploadProjectInformation(params?: {
    body?: {
'RequestUserId'?: number;
'ProjectId'?: number;
'DocumentGroupId'?: string;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.projectsUploadProjectInformation$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
